import { ComparisonPageTemplate } from "@/components/ComparisonPageTemplate";
import { Brain, Users, Zap } from "lucide-react";

const CSWvsCanva = () => {
  return (
    <ComparisonPageTemplate
      platformName="Canva Quiz Maker"
      platformShortName="Canva"
      platformUrl="https://canva.com/quiz-maker"
      seoTitle="CSW vs Canva Quiz Maker"
      seoDescription="Compare CSW and Canva Quiz Maker for visual quizzes. Discover why CSW is the best Canva Quiz alternative with free AI-powered quizzes and study features."
      seoKeywords="CSW vs Canva, Canva Quiz Maker alternative, visual quiz creator, interactive quiz builder, study tools"
      canonicalUrl="https://csw.live/quizzes/csw-vs-canva/"
      heroDescription="Want to design beautiful visual quizzes? Compare CSW and Canva Quiz Maker to find the best platform for your needs."
      alternativeDescription="CSW offers a study-focused alternative to Canva Quiz Maker with AI-powered quiz generation, collaborative study rooms, and integrated learning tools—all free."
      background="Canva's quiz maker is part of its design suite. It offers no‑code, drag‑and‑drop tools for creating simple, single‑question quizzes that can be embedded in presentations or shared via link. Users can choose from quiz templates, customize the design using Canva's media library, allow up to ten answer options and change choices even after responses have been collected. Real‑time results are displayed in the editor and data can be exported."
      pros={[
        { text: "Intuitive design environment – The drag‑and‑drop editor makes building quizzes easy for non‑technical users", source: "canva", sourceUrl: "https://canva.com" },
        { text: "Visual customization – Users can customize fonts, colors, spacing and add photos, audio and other media to match their brand", source: "canva", sourceUrl: "https://canva.com" },
        { text: "Real‑time results and data export – Responses are tallied instantly and can be exported to CSV or image formats", source: "canva", sourceUrl: "https://canva.com" },
        { text: "Easy sharing – Quizzes can be shared via link or embedded into presentations and social posts", source: "canva", sourceUrl: "https://canva.com" },
      ]}
      cons={[
        { text: "Limited question types – Currently supports only single‑question quizzes with text‑based options (e.g., multiple choice, true/false, fill‑in‑the‑blank)", source: "canva", sourceUrl: "https://canva.com" },
        { text: "Basic analytics – Detailed insights and quiz data are reserved for Canva Pro subscribers", source: "canva", sourceUrl: "https://canva.com" },
        { text: "No dedicated proctoring or advanced logic – Lacks features like question branching, timers, or secure test settings found in dedicated quiz tools" },
        { text: "Form limits – Forms and quizzes can have up to ten questions per form and only 20 form elements per design" },
      ]}
      cswFeatures={[
        { text: "AI quiz generation", available: true },
        { text: "Study-optimized design", available: true },
        { text: "Collaborative study", available: true },
        { text: "Flashcard creation", available: true },
        { text: "Productivity tools", available: true },
        { text: "100% free", available: true },
      ]}
      competitorFeatures={[
        { text: "Visual design tools", available: true },
        { text: "Custom layouts", available: true },
        { text: "No AI generation", available: false },
        { text: "Not study-focused", available: false },
        { text: "No study rooms", available: false },
        { text: "Premium features cost", available: false },
      ]}
      benefits={[
        { icon: Brain, title: "AI-Powered", description: "Generate quizzes automatically from content." },
        { icon: Users, title: "Study-Focused", description: "Built specifically for learning." },
        { icon: Zap, title: "Complete Platform", description: "Quizzes, flashcards, and study rooms." },
      ]}
      forStudentsText="While Canva excels at visual design, CSW is purpose-built for studying. Get AI quiz generation, collaborative features, and productivity tools designed specifically for learners."
      pricingText="Canva Pro costs $12.99/month for premium features. CSW offers AI-powered study tools, collaboration features, and more completely free."
      competitorPrice="$12.99/mo"
    />
  );
};

export default CSWvsCanva;
